<template lang="pug">
  div(v-if="timer")
    | {{ timer }}
</template>

<script>
import moment from 'moment'

export default {
  name: 'Countdown',
  props: {
    endDate: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'client'
    }
  },
  data () {
    return {
      now: new Date(),
      interval: null
    }
  },
  computed: {
    timer () {
      let endDate = moment(moment(this.endDate).add(1, 'day'))
      if (0 < endDate - this.now) {
        if (this.type === 'client') {
          return this.$t('transit.offerIn', { time: moment.utc(endDate - this.now).format('HH[h]mm[m]ss') })
        } else {
          return this.$t('transit.responseIn', { time: moment.utc(endDate - this.now).format('HH[h]mm[m]ss') })
        }
      }
    }
  },
  mounted () {
    this.interval = setInterval(() => {
       this.now = new Date()
    }, 1000)
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
}
</script>
